import React from 'react';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';

import bluefitLogo from '../../Assets/frontbpo/clients/bluefit.png';
import oesteLogo from '../../Assets/frontbpo/clients/oeste.png';
import guepLogo from '../../Assets/frontbpo/clients/guep.png';
import ecrossLogo from '../../Assets/frontbpo/clients/ecross.png';
import femmeLogo from '../../Assets/frontbpo/clients/femme.png';
import regueraLogo from '../../Assets/frontbpo/clients/reguera.png';
import genLogo from '../../Assets/frontbpo/clients/gen.png';
import edelwhiteLogo from '../../Assets/frontbpo/clients/edelwhite.png';

const PARTNERS = [
  { name: 'Bluefit', logo: bluefitLogo },
  { name: 'Oeste', logo: oesteLogo },
  { name: 'Guep', logo: guepLogo },
  { name: 'Ecross', logo: ecrossLogo },
  { name: 'Femme', logo: femmeLogo },
  { name: 'Regera', logo: regueraLogo },
  { name: 'GEN', logo: genLogo },
  { name: 'Edel White', logo: edelwhiteLogo },
];

function Partners() {
  return (
    <section className="partners-section" id="parceiros" aria-labelledby="partners-heading">
      <Container>
        <h2 id="partners-heading" className="section-title">Alguns de nossos clientes</h2>
        <Swiper
          modules={[Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={4}
          speed={2000}
          loop
          autoplay={{
            delay: 2300,
            disableOnInteraction: false,
          }}
          navigation
          className="my-partners-swiper"
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 12 },
            768: { slidesPerView: 3, spaceBetween: 24 },
            1024: { slidesPerView: 4, spaceBetween: 30 },
          }}
        >
          {PARTNERS.map((partner) => (
            <SwiperSlide key={partner.name}>
              <div className="partner-col">
                <img src={partner.logo} alt={`Logo ${partner.name}`} className="partner-logo" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
}

export default Partners;
